import React from 'react'
import SearchLine from './SearchLine'

const RetailCommsSearchSection = ({ bulletinItems }) => <div data-cy="latest" className="max-w-xl">
  {bulletinItems.map((item, index) => <SearchLine key={index} {...item} />)}
</div>

export default RetailCommsSearchSection
